import {TransactionLineCreationInfo} from '@/types/transaction/TransactionLineCreationInfo'
import {cloneDeep} from 'lodash'
import {floatsAreEqual} from '@/transaction/create-transaction/EntryLineValidator'


// TODO remove? responsibility should lie elsewhere
export const checkLinesDecimalAmount = (lines: TransactionLineCreationInfo[]) => {
    const newLines = cloneDeep(lines)
    const debitAmount = newLines.reduce((acc, line) => line.amount > 0 ? acc + line.amount : acc, 0)
    const creditAmount = newLines.reduce((acc, line) => line.amount < 0 ? acc - line.amount : acc, 0)
    if (floatsAreEqual(debitAmount, creditAmount) && !floatsAreEqual(debitAmount, creditAmount, 0)) {

        newLines.forEach(line => {
                if (newLines.find(l => l.amount !== line.amount || l.amount !== -line.amount)) {
                    line.amount = Number(line.amount.toFixed(2))
                }
            }
        )
    }
    return newLines
}